var plugin_rtlignore_default = {
  "alignLeft": "k-jVX",
  "textWrapNowrap": "hHOdr",
  "alignRight": "sPJg8",
  "alignCenter": "hnBmT",
  "sizeFullWidth": "qaaii",
  "renderedInTable": "bdgr-",
  "sizeOriginal": "LfwQs",
  "sizeContent": "rmvTO",
  "sizeSmall": "cVq-y",
  "sizeSmallCenter": "KAiRW",
  "flex": "x5r-5",
  "atomic": "rTpn3",
  "embed": "w1nYr",
  "horizontalScrollbar": "_-1G-S",
  "pluginContainerMobile": "WMX0p"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
